import { render, staticRenderFns } from "./BlogPostsSidebarLast.vue?vue&type=template&id=77935341&scoped=true&"
import script from "./BlogPostsSidebarLast.vue?vue&type=script&lang=js&"
export * from "./BlogPostsSidebarLast.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsSidebarLast.vue?vue&type=style&index=0&id=77935341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77935341",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPostImage: require('/home/circleci/repo/components/blog/BlogPostImage.vue').default})
